<template>
    <div class="pt-2">
        <v-card flat>
            <v-form>
                <v-row no-gutters align="center" justify="space-around">
                    <v-col cols="12" sm="1" style="text-align: right">
                        <label>适用门店:</label>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <pd-shop-multiple-list v-model="filter.shopIds" isSearch></pd-shop-multiple-list>
                    </v-col>
                    <v-col cols="12" sm="1" style="text-align: right">
                        <label>年度：</label>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-text-field
                           v-model="filter.year"
                           single-line
                           outlined
                           dense></v-text-field>
                    </v-col>
<!--                  <v-col cols="12" sm="1" style="text-align: right">-->
<!--                    <label>状态：</label>-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" sm="2">-->
<!--                    <v-select-->
<!--                        v-model="filter.status"-->
<!--                        :items="statusList"-->
<!--                        item-text="name"-->
<!--                        item-value="id"-->
<!--                        clearable-->
<!--                        outlined-->
<!--                        dense-->
<!--                    ></v-select>-->
<!--                  </v-col>-->
                    <v-col cols="12" sm="1"></v-col>
                    <v-col cols="12" sm="2">
                        <v-btn color="info" style="margin-right: 5px;" depressed @click="handleSearch"
                        >查询</v-btn>
                        <v-btn depressed @click="handleResetSearch">重置</v-btn>
                    </v-col>
                </v-row>
            </v-form>
            <v-data-table
                    :headers="headers"
                    :items="items"
                    class="elevation-1"
                    :loading="loading"
                    :server-items-length="total"
                    :page.sync="filter.page"
                    :items-per-page.sync="filter.pageSize"
                    @update:page="handlePageChanged"
                    @update:items-per-page="handlePageSizeChanged"
                    style="margin-top: 20px;"
            >
                <template v-slot:item.status="{ item }">
                  <div :style="item.status > 1 ? 'color: red' : ''">
                    <span v-if="item.status == 1">待提交</span>
                    <span v-if="item.status == 2">已提交</span>
                    <span v-if="item.status == 3">集团审批通过</span>
                    <span v-if="item.status == 4">财务审批通过</span>
                    <span v-if="item.status == 5">审批不通过</span>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn text color="primary" large @click="view(item)" style="font-size: 17px;"
                    >查看</v-btn>
                    <v-btn text color="primary" large @click="edit(item)" style="font-size: 17px;"
                    >修改</v-btn>
                    <v-btn text color="primary" large @click="exportInfo(item)" style="font-size: 17px;"
                    >导出</v-btn>
                    <v-btn text color="primary" large @click="doImport(item)" style="font-size: 17px;"
                    >导入</v-btn>
                </template>
                <template v-slot:no-data> 查询出错或没有数据 </template></v-data-table
            >
        </v-card>
      <!--导入弹窗-->
      <v-dialog v-model="auditDialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >导入工程预算数据</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-file-input
                      truncate-length="15"
                      label="选择excel"
                      small-chips
                      dense
                      v-model="importFile"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="handleImport"> 确认 </v-btn>
            <v-btn color="primary" text>
              <a href="./template/project.xlsx" download="导入模板-工程.xlsx">下载模板</a>
            </v-btn>
            <v-btn text @click="hideAudit"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
    import {default as downloadUtil} from "@/util/downloadUtil";
    import {default as CwBudgetCost} from "@/api/pd/budget/CwBudgetCostApi.js";
    export default {
        data() {
            return {
                currentCostId: '',
                auditDialog: false,
                tab: 'list',
                filter: {
                    shopIds: [],
                    year: '',
                    pageNum: 1,
                    pageSize: 15
                },
                statusList: [
                  {id: 1, name: '待提交'},
                  {id: 2, name: '已提交'},
                  {id: 3, name: '集团审批通过'},
                  {id: 5, name: '审批不通过'}
                ],
                headers: [
                    {
                        text: "记录编号",
                        align: "start",
                        width: 120,
                        sortable: false,
                        value: "id",
                    },
                    { text: "门店名称", value: "mdmc", width: 120, sortable: false },
                    { text: "年度", value: "year", width: 80, sortable: false },
                    { text: "状态", value: "status", width: 80, sortable: false },
                    { text: "最后修改人", value: "updateBy", width: 100, sortable: false },
                    { text: "最后修改时间", value: "updateTime", width: 120, sortable: false },
                    { text: "操作", align: "center", value: "actions", sortable: false, width: 300 },
                ],
                items: [],
                loading: false,
                total: 0,
                options: [
                    {storeId: 6031, storeName: '八佰伴中心'}
                ],
                importFile: undefined
            };
        },
        methods:{
            doImport(item) {
              if (item.status == 1 || item.status == 5) {
                this.currentCostId = item.id;
                this.auditDialog = true;
              } else {
                alert('当前状态不可执行此操作')
              }
            },
            async handleImport() {
              let me = this;
              let file = me.importFile;
              if (!file || !file.size) {
                me.$dialog.error({
                  text: "文件必传",
                  title: "操作失败",
                });
                return;
              }
              let res = await CwBudgetCost.importData({file: file, costId: me.currentCostId});
              console.log("导入结果", res);
              if (res.data.code === 200) {
                if(res.data.data){
                  me.$dialog.error({
                    text: res.data.data,
                    title: "操作失败",
                  });
                }else{
                  me.$dialog.info({
                    text: res.data.msg,
                    title: "操作成功",
                  });
                }
                me.getDataFromApi();
              } else {
                me.$dialog.error({
                  text: res.data.msg + ':' + res.data.msg_detail,
                  title: "操作失败",
                });
              }
              me.hideAudit();
              me.importFile = undefined;
            },
            async downloadTemplate() {
              let res = await CwBudgetCost.exportTemplate();
              downloadUtil.downloadByBlob({ res: res.data, fileName: "导入模板.xlsx" });
            },
            hideAudit() {
              this.currentCostId = '';
              this.auditDialog = false;
            },
            getQueryParams(query) {
                console.log(query)
                return query
            },
            // 搜索
            handleSearch(){
                this.getDataFromApi();
            },
            // 搜索重置
            handleResetSearch(){
                this.filter.year = '';
                this.filter.storeId = '';
                this.getDataFromApi();
            },
            getDataFromApi() {
                let that = this
                let query= this.filter;
                CwBudgetCost.projectList(query).then(resp=>{
                    console.log(resp);
                    let rows =resp.data.data.rows
                    let total=resp.data.data.total
                    this.items=rows
                    this.total=total
                });
            },
            // 获取列表数据
            getDataFromApiA(){
                let query=this.getQueryParams(this.filter);
                let arr = []
                arr = [{
                    id: 1,
                    shopName: '八佰伴中心',
                    year: '2022',
                    status: 1,
                    editor: '系统',
                    editdate: '2022-06-28 13:00:00'
                }]
                this.items = arr
                this.total = 1;
            },
            // 查看
            view(item){
                localStorage.setItem('projectShopIds', JSON.stringify(this.filter.shopIds))
                this.$emit("addCallback", {formStatus:'view', item: item, operate: { type: 1 }})
            },
            // 修改
            edit(item) {
                localStorage.setItem('projectShopIds', JSON.stringify(this.filter.shopIds))
                this.$emit("addCallback", {formStatus:'view', item: item, operate: { type: 2 }})
            },
            // 提交
            submit(item) {

            },
            // 导出
            exportInfo(item) {
                let dateIn = new Date()
                let params = {
                  costId: item.id,
                  storeName: item.mdmc,
                  year: dateIn.getFullYear() + 1
                }
                this.exportData(params);
            },
            async exportData(params) {
              let me = this;
              let res = await CwBudgetCost.exportStoreOrdersItem(params);
              // console.log(res);
              downloadUtil.downloadByBlob({ res: res.data, fileName: "导出结果-工程.xlsx" });
            },
            // 修改页数
            handlePageChanged(pageNum) {
                this.filter.pageNum = pageNum;
                this.getDataFromApi();
            },
            // 修改每页展示条数
            handlePageSizeChanged(pageSize) {
                if (pageSize == -1) {
                    pageSize = 100;
                }
                this.filter.pageNum = 1;
                this.filter.pageSize = pageSize;
                this.getDataFromApi();
            }
        },
        mounted(){
            // this.getDataFromApi();
            // this.getDataFromApiA();
          if (localStorage.getItem('projectShopIds')) {
            let shopIds = localStorage.getItem('projectShopIds')
            shopIds = JSON.parse(shopIds)
            if (shopIds.length > 0) {
              this.filter.shopIds = shopIds
              this.handleSearch()
            }
          }
        }
    };
</script>
<style scoped>
    td{
        font-size: 16px;
        font-weight: 700;
    }
</style>